import { useState, useEffect, useContext, useCallback  } from 'react';
import { useParams } from "react-router-dom";
import axios from 'axios';


import { CcTitle } from '../commonComponents/styledTexts';
import { Icon as Iconify } from '@iconify/react';

import ReportSnippetInfo from './snippetInfo';
import { ReportBar } from './reportBar';



export default function SnippetMemoryCardsReport() {
    const [showLoader, setShowLoader] = useState(false)
    const [snippetInfo, setSnippetInfo] = useState(undefined)
    const [snippetBaseStats, setSnippetBaseStats] = useState(undefined)
    const [snippetWebPageStats, setSnippetWebPageStats] = useState(undefined)
    const [snippetSettings, setSnippetSettings] = useState(undefined)
    const [imageUrl, setImageUrl] = useState('')

  let params = useParams();
      
  useEffect(() => {
      //console.log(params)
    if (params.snippetId !== undefined) {
        setSnippetBaseStats(undefined)
        setSnippetWebPageStats(undefined)
        setSnippetInfo(undefined)
        getSnippetBaseStats(params.snippetId)
        getSnippetWebPageStats(params.snippetId)
        getSnippetInfo(params.snippetId)
    }
  }, [params])

  const getSnippetBaseStats = async (snippetId) => {
    try {  
      const url = `${process.env.REACT_APP_LION_API_URL}/Stats/element/base/${snippetId}`;
      const response = await axios.get(url);
      const data = response.data;

      setSnippetBaseStats(data)


    } catch (error) {
      console.log(error);
    }
  }
  const getSnippetWebPageStats = async (snippetId) => {
    try {  
      const url = `${process.env.REACT_APP_LION_API_URL}/WebPagesStats/base/${snippetId}`;
      const response = await axios.get(url);
      const data = response.data;

      //console.log(data)
      setSnippetWebPageStats(data)


    } catch (error) {
      console.log(error);
    }
  }
  const getSnippetInfo = async (snippetId) => {
    try {  
      const url = `${process.env.REACT_APP_LION_API_URL}/Snippets/${snippetId}?allInfo=true`;
      const response = await axios.get(url);
      const data = response.data;

      //console.log(data)
      setSnippetInfo(data)

      const snippetSettings = JSON.parse(data.snippetSettings)
      console.log(snippetSettings)
      setSnippetSettings(snippetSettings)
  
      const emailEffectType = snippetSettings.emailEffectType
      let image = ''
      switch (emailEffectType) {
        case "gameAnimation":
            image = `data:image/gif;base64,${snippetSettings.emailEffectImg}`
            break
        case "gameScreenshot":
            image = `${snippetSettings.emailEffectImg[0]}`
            break
        case "static":
            image = `${snippetSettings.emailEffectStaticImg}`
            break
        default:
            break
      }
      setImageUrl(image)

    } catch (error) {
      console.log(error);
    }
  }
  const getWebPageClicks = () => {
    if (snippetWebPageStats === undefined) return undefined

    let result = 0;
    for (const row of snippetWebPageStats) {
        result += row.totalClicks
    }
    return result
  }

    return <div>
            <CcTitle>Element Report Memory Cards</CcTitle>
            <div className='mt-4'>
                <ReportSnippetInfo snippetInfo={snippetInfo} />
            </div>
            <div className='mt-4'>
                <ReportBar stats={[{title: 'Email Image Views', value: snippetBaseStats ? snippetBaseStats.totalOpens : undefined },
                                    {title: 'Email Clicks', value: snippetBaseStats ? snippetBaseStats.totalClicks : undefined},
                                    {title: 'Web Page Clicks', value: getWebPageClicks()},
                                    ]} />
            </div>
            <div className='mt-6 text-xl text-ccColorDarkTeal font-semibold'>Puzzle Image</div>
            <div className='bg-slate-200 rounded p-4 w-fit'>
                {snippetSettings &&
                    <img src={imageUrl} />
                }
            </div>
    </div>
}